import type {
    ReturnCommerceEnrollmentToShoppingRequest,
    ReturnCommerceEnrollmentToShoppingResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";

export const returnCommerceEnrollmentToShoppingOperation: CommerceOperation<
    ReturnCommerceEnrollmentToShoppingRequest,
    ReturnCommerceEnrollmentToShoppingResponse
> = Object.freeze({
    name: "commerce.enrollment.return-to-shopping",
});
